import { render } from "./LogoutAlert.vue?vue&type=template&id=a6eb38ea"
import script from "./LogoutAlert.vue?vue&type=script&lang=js"
export * from "./LogoutAlert.vue?vue&type=script&lang=js"
script.render = render

export default script